import angular from 'angular'
import directive from './directive'

export default angular
  .module('ellipsis.metaElement', [])
  .directive('metaElement', directive)
